import { useState } from "react";
import { api, formatApiError } from "../../api/client";
import { useAuth } from "../../store/auth";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { toast } from "sonner";

export default function SettingsProfile() {
  const { user, refreshMe } = useAuth();
  const [name, setName] = useState(user?.name || "");
  const [currentPassword, setCurrent] = useState("");
  const [newPassword, setNew] = useState("");
  const [confirm, setConfirm] = useState("");
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (newPassword && newPassword !== confirm) {
      setError("Las contraseñas no coinciden.");
      return;
    }
    setSaving(true);
    try {
      const payload = { name };
      if (newPassword) {
        payload.current_password = currentPassword;
        payload.new_password = newPassword;
      }
      await api.put("/me", payload);
      await refreshMe();
      setCurrent("");
      setNew("");
      setConfirm("");
      toast.success("Perfil actualizado.");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || "No se pudo guardar.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div data-testid="settings-profile-page" className="max-w-xl">
      <h1 className="text-[20px] font-semibold tracking-tight text-slate-900">Mi perfil</h1>
      <p className="text-[14px] text-slate-500 mt-1">Actualiza tu nombre y contraseña.</p>

      <form onSubmit={submit} className="mt-6 space-y-4 bg-white border border-slate-200 rounded-md p-6">
        <div>
          <Label>Correo</Label>
          <Input value={user?.email || ""} disabled />
        </div>
        <div>
          <Label>Nombre</Label>
          <Input data-testid="profile-name" value={name} onChange={(e) => setName(e.target.value)} />
        </div>

        <div className="pt-4 border-t border-slate-200">
          <h2 className="text-[14px] font-semibold text-slate-900 mb-3">Cambiar contraseña</h2>
          <div className="space-y-4">
            <div>
              <Label>Contraseña actual</Label>
              <Input data-testid="profile-current-password" type="password" value={currentPassword} onChange={(e) => setCurrent(e.target.value)} />
            </div>
            <div className="grid grid-cols-2 gap-4">
              <div>
                <Label>Nueva contraseña</Label>
                <Input data-testid="profile-new-password" type="password" value={newPassword} onChange={(e) => setNew(e.target.value)} />
              </div>
              <div>
                <Label>Confirmar nueva</Label>
                <Input data-testid="profile-confirm-password" type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} />
              </div>
            </div>
          </div>
        </div>

        {error && <div data-testid="profile-error" className="text-[12px] text-destructive">{error}</div>}

        <div className="pt-2">
          <Button type="submit" disabled={saving} data-testid="profile-save">
            {saving ? "Guardando..." : "Guardar cambios"}
          </Button>
        </div>
      </form>
    </div>
  );
}
